import { Component, Input } from '@angular/core';

import { ConsumerHandlerProvider } from '../../providers/consumer-handler';
import { Globals } from '../../providers/globals';

@Component({
  selector: 'consumer-card',
  templateUrl: 'consumer-card.html'
})
export class ConsumerCardComponent {
	@Input('userId') userId;

	userProfileImagePath: any;
	consumerData: any; 

	constructor(
		public consumerHandlerProvider: ConsumerHandlerProvider,
		public globals: Globals,
	) {
		this.userProfileImagePath = "assets/images/profile.png";

		this.loadUser();
	}

	loadUser(){
		this.consumerHandlerProvider.getUserInfo({
		  userId: this.consumerHandlerProvider.currentIdentityUserId,
		  cb:(userData)=>{
		    this.consumerData = userData

		    if(this.consumerData.ImagePath){
		      this.userProfileImagePath = this.globals.fileUrl + this.consumerData.ImagePath;  
		    }               
		  }
		})
	}
}



// WEBPACK FOOTER //
// ./src/components/consumer-card/consumer-card.ts